import React from "react";

const SchoolProspectus = () => {
  return <div>School Prospectus</div>;
};

export default SchoolProspectus;
